import { Directive, OnInit, inject } from '@angular/core';
import { LDWDocument } from '../../models/LDWDocument';
import { DocumentHelper } from '../../helpers/document-helper';
import { MatDialog } from '@angular/material/dialog';
import { LdwRouterService } from '../../../route/ldw-router.service';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { DocumentService } from '../../services/document.service';
import { TranslateService } from '@ngx-translate/core';
import { InfoService } from '../../services/info.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentDetailResolved } from '../../models/document-detail-resolved';
import { SelectionArguments } from '../../models/selection-arguments';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { BookmarkService } from '../../../bookmarks/bookmark.service';
import { PlanningJob } from '../../models/planning-job';

@Directive()
export class DocumentPageBase implements OnInit {
  document: LDWDocument | undefined = undefined;
  documentHelper: DocumentHelper;
  public search = '';
  public pageNumber = 1;
  public pageZoom = 1;
  public selectedPlanningJob

  constructor(
    protected dialog: MatDialog,
    protected routerService: LdwRouterService,
    protected webDokuService: WebdokuService,
    protected documentService: DocumentService,
    protected translate: TranslateService,
    protected infoService: InfoService,
    protected route: ActivatedRoute,
    protected bookmarkService: BookmarkService
  ) {
    this.documentHelper = new DocumentHelper(dialog, routerService, translate);
    this.selectedPlanningJob = this.webDokuService.selectedPlanningJob
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const documentResolved: DocumentDetailResolved = data['document'];
      if (documentResolved.documentDetail) {
        this.document = documentResolved.documentDetail;
        const webDokuId = this.route.snapshot.paramMap.get('wd') ?? '';
        this.updateHistory(webDokuId, this.document.id);
        // search is an optional QUERY param
        this.search = this.route.snapshot.queryParamMap.get('search') ?? '';
        this.pageNumber = +(this.route.snapshot.queryParamMap.get('page') ?? '1');
        this.pageZoom = +(this.route.snapshot.queryParamMap.get('zoom') ?? '1');
      } else {
        this.error(documentResolved.docId);
      }

      if (documentResolved.error) {
        this.infoService.setStatus(documentResolved.error);
      } else {
        this.infoService.clearStatus();
      }
    });
  }

  error(docid: string) {
    this.documentHelper.documentNotFound(docid);
  }

  get viewVisible(): boolean {
    return this.document != undefined && this.document.id != '';
  }

  statusHasChanged(args: SelectionArguments) {
    if (this.document == undefined || this.document.id == undefined) {
      return;
    }

    this.documentService.updateStatus(this.document.id, args.id).subscribe((value) => {
      if (value.success) {
        if (this.document != undefined) {
          this.document.status = this.webDokuService.getStatusById(args.id).clone();
        }
      } else {
        this.dialog.open(ErrorDialogComponent, {
          data: {
            title: 'ERROR.DLG_ERROR_TITLE',
            message: value.message,
          },
        });
      }
    });
  }

  protected get isReadOnly(): boolean {
    return true;
  }

  public get isBookmarkVisible(): boolean {
    return this.bookmarkService.bookmarksEnabled;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected updateHistory(webDokuId: string, docId: string) { }

  close() {
    this.routerService.navigateBack();
  }
}
